import { TeamDirectoryBox } from '@lemontaps/lib/types/api';
import ArrowCircleRightOutlinedIcon from '@mui/icons-material/ArrowCircleRightOutlined';
import { Button, IconButton } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Swiper, SwiperSlide } from 'swiper/react';
import ContentBoxUi from '../../components/ContentBoxUI';
import TeamMemberListPopup from './components/popup';
import TeamMember from './components/teamMember';
import TooltipInfo from '@/components/TooltipInfo';
import { customCssClasses } from '@lemontaps/lib/constants';

export const SLIDE_SIZE = '14rem';
export default function TeamDirectoryBoxSection({ config }: { config: TeamDirectoryBox }) {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const { t } = useTranslation();

  return (
    <>
      <ContentBoxUi
        containerClassName={customCssClasses.teamDirectoryBox.container.className}
        titleClassName={customCssClasses.teamDirectoryBox.title.className}
        title={config.label}
        isEdit={false}
        actionButton={
          config.team.length > 2 ? (
            <TooltipInfo text={t('showAll')} onHover>
              <IconButton
                onClick={() => setIsPopupOpen(true)}
                aria-label={t('teamDirectoryShowAll')}
              >
                <ArrowCircleRightOutlinedIcon />
              </IconButton>
            </TooltipInfo>
          ) : undefined
        }
        sx={{ border: 'none', boxShadow: 'none' }}
      >
        <Swiper spaceBetween={5} slidesPerView='auto'>
          {config.team.slice(0, 19).map(teamMember => (
            <SwiperSlide key={teamMember.key} style={{ width: SLIDE_SIZE, height: 'unset' }}>
              <TeamMember teamMember={teamMember} />
            </SwiperSlide>
          ))}
          {config.team.length > 19 && (
            <SwiperSlide style={{ height: 'auto', padding: '10px', width: SLIDE_SIZE }}>
              <Button
                variant='text'
                onClick={() => setIsPopupOpen(true)}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '100%',
                  height: '100%',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <ArrowCircleRightOutlinedIcon style={{ height: '35px', width: '35px' }} />
                {t('viewAll')}
              </Button>
            </SwiperSlide>
          )}
        </Swiper>
      </ContentBoxUi>

      <TeamMemberListPopup
        open={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
        title={config.label ?? ''}
        teamMembers={config.team}
      />
    </>
  );
}
